import React from "react";
import { Layout } from "src/components/layout/Layout";
import { ModuleRouter } from "src/components/molecules";
import { WorkOrderRoute } from "./workorder.routes";

type Props = {};

export function WorkOrderModule({}: Props): React.ReactElement {
  console.log("Work Order Module Rendered");
  return (
    <Layout>
      {WorkOrderRoute.subRoutes && (
        <ModuleRouter subRoutes={WorkOrderRoute.subRoutes} path={WorkOrderRoute.path} />
      )}
    </Layout>
  );
}
